import { useSelector, useDispatch } from 'react-redux';

const useUserSession = () => {
  const session = useSelector(state => state.oidcSession);
  const dispatch = useDispatch();
  const { onLoaded } = dispatch.oidcSession;

  return { session: session && session.token_type ? session : null, onSessionLoaded: onLoaded };
};

export default useUserSession;
